let Backbone = window.Backbone;


export default Backbone.Model.extend({
  defaults: {
    thumb: '',
    name: '',
    title: '',
    excerpt: '',
    shareCount: 0,
    type: 'text',
    permalink: '',
    tags: []
  }
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/grid/Item.model.js